import React, { useContext, useMemo } from 'react';
import operationService from '../../../../services/operationService';
import Context from './context';
import { Action, ApiState, IdRoute } from '../../../../types';
import { Toolkit } from '../../../../services/types/Toolkit';
import { serviceReducer } from '../../../../shared/hooks/serviceReducer';
import useServiceReducer from '../../../../shared/hooks/useServiceReducer';
import MainContext from '../../../App/MainProvider/context';

const toolkitReducer = (
  state: ApiState<Toolkit[], string>,
  action: Action<Toolkit[], string>
): ApiState<Toolkit[], string> => serviceReducer(state, action);

const ToolkitsProvider: React.FC<IdRoute> = ({ id: operationId, children }) => {
  const { inSuperUserMode, inGuidanceServiceMode } = useContext(MainContext);
  const [toolkits, , , , , reload] = useServiceReducer(
    operationService.getToolkits,
    toolkitReducer,
    operationId,
    [inSuperUserMode(), inGuidanceServiceMode()]
  );

  const value = useMemo(() => toolkits && { toolkits, reload }, [toolkits, reload]);

  return value && <Context.Provider value={value}>{children}</Context.Provider>;
};

export default ToolkitsProvider;
